// The "Privacy notice" link in the public pages' footers (Session ASQ, Stream G, Item 5): the customer portal (sign-in
// and every signed-in page, through PortalFooter), subcontractor onboarding, the quote accept and renewal pages (the
// shared AcceptQuote Footer) and the customer feedback (NPS) survey.
//
// IT RENDERS NOTHING AT ALL until the notice is known to be published: no gap, no loading text, no placeholder, and
// nothing when the read fails. The link only exists once an admin has saved a notice in Settings, and disappears from a page again
// when they clear it. One request per page load however many links the page carries (src/lib/privacyNotice.ts).
//
// It opens in a new tab, so a customer part-way through accepting a quote or answering a survey does not lose the page.
//
// COLOUR (brand.md, "shared components rendered on more than one canvas"): the default is the technical blue #2CB9F3,
// correct for the MOST COMMON canvas, the dark #050816 of the portal and survey pages (8.9:1). A caller on a light canvas passes
// its own ink (the quote and renewal pages pass their page purple; the subcontractor onboarding and payment details
// pages, on the light subcontractor shell since commit 01122ec6, pass --sp-purple), never a change to this default.
import { useEffect, useState } from "react";
import { loadPrivacyNotice } from "../lib/privacyNotice";

export const PRIVACY_NOTICE_LINK_DEFAULT_COLOUR = "#2CB9F3";

export function PrivacyNoticeLink({
  className = "",
  linkClassName = "",
  color = PRIVACY_NOTICE_LINK_DEFAULT_COLOUR,
}: {
  // Classes for the wrapping paragraph (spacing, alignment), present only when the link is.
  className?: string;
  linkClassName?: string;
  color?: string;
}) {
  const [published, setPublished] = useState(false);

  useEffect(() => {
    let live = true;
    void loadPrivacyNotice().then((s) => {
      if (live && s.status === "published") setPublished(true);
    });
    return () => {
      live = false;
    };
  }, []);

  if (!published) return null;
  return (
    <p className={className} data-privacy-notice-link="">
      <a href="/privacy" target="_blank" rel="noopener noreferrer" className={`font-menu underline ${linkClassName}`.trim()} style={{ color }}>
        Privacy notice
      </a>
    </p>
  );
}
